/**
 * @generated SignedSource<<1e7db45a2d7b580d13d6f00a0ffb1e87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MoqStepType = "CUSTOM" | "FIXED";
export type moqRuleEditor_MoqRuleDetailQuery$variables = {
  id: string;
};
export type moqRuleEditor_MoqRuleDetailQuery$data = {
  readonly moqRule: {
    readonly customTiers: string;
    readonly fixedStep: number;
    readonly id: string;
    readonly minimumQuantity: number;
    readonly moqRuleID: number;
    readonly name: string;
    readonly printTypes: ReadonlyArray<{
      readonly printTypeID: number;
    }>;
    readonly products: ReadonlyArray<{
      readonly productID: number;
    }>;
    readonly stepType: MoqStepType;
  };
};
export type moqRuleEditor_MoqRuleDetailQuery = {
  response: moqRuleEditor_MoqRuleDetailQuery$data;
  variables: moqRuleEditor_MoqRuleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MoqRule",
    "kind": "LinkedField",
    "name": "moqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "moqRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumQuantity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stepType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fixedStep",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customTiers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRuleProduct",
        "kind": "LinkedField",
        "name": "products",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRulePrintType",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "printTypeID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "376cea156a9b20b0b94516af7151cca5",
    "id": null,
    "metadata": {},
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "operationKind": "query",
    "text": "query moqRuleEditor_MoqRuleDetailQuery(\n  $id: ID!\n) {\n  moqRule(id: $id) {\n    id\n    moqRuleID\n    name\n    minimumQuantity\n    stepType\n    fixedStep\n    customTiers\n    products {\n      productID\n    }\n    printTypes {\n      printTypeID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19d5b68e250623eaea28850075568e19";

export default node;
